export default "__VITE_ASSET__E9Ht_LyZ__"